if (!customElements.get('press-release')) {
  class PressRelease extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.swiperContainer = this.querySelector('.press-release__slider');
      this.paginationEl = this.querySelector('.swiper-pagination');
      this.prevButtonEl = this.querySelector('.swiper-button-prev');
      this.nextButtonEl = this.querySelector('.swiper-button-next');
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    getConfig() {
      return {
        slidesPerView: 1,
        slidesOffsetAfter: 12,
        slidesOffsetBefore: 12,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        pagination: {
          el: this.paginationEl,
          type: 'fraction',
        },
        keyboard: {
          enabled: true,
        },
        a11y: {
          prevSlideMessage: 'Previous press release',
          nextSlideMessage: 'Next press release',
        },
        breakpoints: {
          768: {
            slidesPerView: 1.3,
            slidesPerGroup: 1,
            spaceBetween: 20,
            slidesOffsetAfter: 20,
            slidesOffsetBefore: 20,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 12,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
        },
        navigation: {
          nextEl: this.nextButtonEl,
          prevEl: this.prevButtonEl,
        },
      };
    }

    init() {
      if (!this.swiperContainer) return;
      if (typeof Swiper === 'undefined') return;
      const slides = this.swiperContainer.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;
      this.swiper = new Swiper(this.swiperContainer, this.getConfig());
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }
  customElements.define('press-release', PressRelease);
}
